import createSlice from "admin/store/create-slice";
import initialState from "admin/store/initial-state-schema";
import { getApiUrl } from 'shared-kernel/helpers';

const name = 'productsimilar';

const slice = createSlice({
    name,
    initialState,
    reducers: {
        requested: state => ({
            ...state,
            isFetching: true
        }),
        failed: state => ({
            ...state,
            isFetching: false,
            isFailed: true
        }),
        itemsReceived: (state, payload) => ({
            ...state,
            isFetching: false,
            items: payload.data.items,
            total: payload.data.total
        }),
        submitReceived: state => ({
            ...state,
            isFetching: false
        })
    }
});

const { requested, failed, itemsReceived, submitReceived } = slice.actions;

export default slice.reducer;

export const getAll = data => ({
    types: [requested.type, itemsReceived.type, failed.type],
    method: 'post',
    url: getApiUrl(name, 'getall'),
    payload: data
});

export const submit = data => ({
    types: [requested.type, submitReceived.type, failed.type],
    method: 'post',
    url: getApiUrl(name, 'submit'),
    payload: data
});